import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import plugin from './plugin/index'
import store from './store'
import i18n from './lang'
import './assets/custom-theme/index.css'
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.use(plugin)
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js